var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_362_1",
    "data-name": "Componente 362 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_11739",
    "data-name": "Rettangolo 11739",
    width: 37,
    height: 37,
    rx: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_19159",
    "data-name": "Raggruppa 19159",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_9848",
    "data-name": "Rettangolo 9848",
    width: 20,
    height: 14,
    transform: "translate(2 8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-photo",
    "data-name": "Icon material-photo",
    d: "M28.5,25.833V7.167A2.675,2.675,0,0,0,25.833,4.5H7.167A2.675,2.675,0,0,0,4.5,7.167V25.833A2.675,2.675,0,0,0,7.167,28.5H25.833A2.675,2.675,0,0,0,28.5,25.833ZM11.833,18.5l3.333,4.013L19.833,16.5l6,8H7.167Z",
    transform: "translate(-4.5 -4.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_1030",
    "data-name": "Ellisse 1030",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(5 6)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImage);
export default __webpack_public_path__ + "static/media/edit-image.8aa5cf65bfe65f23db7de316f9cb9383.svg";
export { ForwardRef as ReactComponent };